import { Box, Image } from '@user-portal/wikr-components';
import styled, { css } from 'styled-components';

import mediaQueries from 'theme/mediaQueries';
import { viewPortWithoutHeader } from 'theme/selectors';

export const AuthContainer = styled.div`
    width: 100vw;
    min-height: ${viewPortWithoutHeader()};
    display: flex;
    flex-direction: row;
    align-items: start;

    ${mediaQueries.tablet} {
        align-items: center;
    }

    ${mediaQueries.tabletLandscape} {
        align-items: stretch;
    }
`;

export const AuthForm = styled.div`
    position: relative;
    width: ${({ theme }) => css`calc(400px + (${theme['default-indent']}px * 2))`};
    margin: 0 auto;
    padding: 32px 0;

    ${mediaQueries.tabletLandscape} {
        padding-top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;

export const AuthImage = styled(Box)`
    display: none;
    min-height: ${viewPortWithoutHeader()};
    width: 50%;
    height: 100%;
    position: relative;
    background: linear-gradient(180deg, #0c0c0d 22.47%, #141924 59.01%, #101010 81.71%);

    * {
        height: 100%;
        object-fit: cover;
    }

    ${mediaQueries.tabletLandscape} {
        display: block;
    }
`;

export const LoginMan = styled(Image)`
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    max-height: 806px;
`;

export const LoginText = styled(Image)`
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    position: absolute;
    bottom: 684px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 545px;
`;
